import React, { useCallback, useState } from 'react';

const TikTokIcon = () => {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = useCallback(() => {
    setIsHovered(true);
  }, []);

  const handleMouseLeave = useCallback(() => {
    setIsHovered(false);
  }, []);

  return (
    <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      {isHovered ? (
        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="25" height="25" rx="6" fill="#000000" />
          <path
            d="M16.4992 3H13.145V16.6232C13.145 18.2464 11.855 19.5797 10.2496 19.5797C8.64418 19.5797 7.35413 18.2464 7.35413 16.6232C7.35413 15.029 8.61552 13.7246 10.1636 13.6667V10.2464C6.75211 10.3043 4 13.1159 4 16.6232C4 20.1594 6.80944 23 10.2783 23C13.747 23 16.5565 20.1304 16.5565 16.6232V9.63767C17.8179 10.5652 19.3659 11.1159 21 11.1449V7.72464C18.4773 7.63768 16.4992 5.55072 16.4992 3Z"
            fill="white"
          />
        </svg>) : (
        <svg width="25" height="25" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.771484" width="25" height="25" rx="6" fill="#FEFEFE" />
          <path
            d="M17.2707 3H13.9165V16.6232C13.9165 18.2464 12.6265 19.5797 11.0211 19.5797C9.41567 19.5797 8.12562 18.2464 8.12562 16.6232C8.12562 15.029 9.387 13.7246 10.9351 13.6667V10.2464C7.52359 10.3043 4.77148 13.1159 4.77148 16.6232C4.77148 20.1594 7.58093 23 11.0497 23C14.5185 23 17.328 20.1304 17.328 16.6232V9.63767C18.5894 10.5652 20.1374 11.1159 21.7715 11.1449V7.72464C19.2487 7.63768 17.2707 5.55072 17.2707 3Z"
            fill="#2B2A29"
          />
        </svg>)}
    </div>
  );
};

export default TikTokIcon;